// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    'report.page.title.customer_statement': 'Customer Statement',
    'report.page.title.vendor_statement': 'Vendor Statement',

    'report.label.date': 'Date',
    'report.label.generate_for_customer': 'Customer',
    'report.label.generate_for_vendor': 'Vendor',
    'report.label.description': 'Description',
    'report.label.amount': 'Amount',
    'report.label.balance': 'Balance',
    'report.label.status': 'Status',

    'report.label.closing_balance': 'Closing Balance',
    'report.label.opening_balance': 'Opening Balance',

    'report.message.no_records': 'No records found',

    'generic.grand.total': 'Grand Total',
};
